import Vue from 'vue'
import Vuex from 'vuex'
//
import modules from './modules'
//
Vue.use(Vuex)
//
export default new Vuex.Store({
	state: {
		activePage: 'Home'
	},

	mutations: {
		setPage (state, page) {
			state.activePage = page
		}
	},

	modules
})



// WEBPACK FOOTER //
// ./src/store/index.js